<script setup>
    import { UserGroupIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <UserGroupIcon />
</template>
